module.exports = __webpack_public_path__ + "img/woman.25ccd912.png";